/* eslint-disable*/
import axios from 'axios';
// import { Toast } from 'vant';
import domain from './config';
import md5 from 'md5';
/**
 * 区分环境
 */
axios.defaults.baseURL = domain;
/**
 * 设置请求超时
 */
axios.defaults.timeout = 1000 * 12;
/**
 * common请求头
 */
axios.defaults.headers.common['timestamp'] = new Date().getTime();
/**
 * post请求头
 */
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';


/**
 * 提示函数
 * 禁止点击蒙层、显示2秒后关闭
 */
// const tip = (msg) => {
//   Toast({
//     message: msg,
//     duration: 2000,
//     forbidClick: true,
//   });
// };
/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
// const errorHandle = (status, other) => {
// 状态码判断
// switch (status) {
//   // 401: 未登录状态，跳转登录页
//   case 401:
//     toLogin();
//     break;
//   // 403 token过期
//   // 清除token并跳转登录页
//   case 403:
//     tip('登录过期，请重新登录');
//     localStorage.removeItem('token');
//     setTimeout(() => {
//         toLogin();
//     }, 1000);
//     break;
//   // 404请求不存在
//   case 404:
//     tip('请求的资源不存在');
//     break;
//   default:
//     console.log(other);
// }
// };

// 把对象按照属性名的字母顺序进行排列
function objKeySort(obj) {
  let newkey = Object.keys(obj).sort();
  let newObj = {};
  for (let i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]];
  }
  return newObj;
}

// 获取请求头sign字段的md5值
function getHeaderMd5Sign(obj) {
  let sortObj = objKeySort(obj);
  let sortObjStr = '';
  for (const i in sortObj) {
    // if (sortObj[i] != '') sortObjStr += `${i}=${sortObj[i]}&`;
    sortObjStr += `${i}=${sortObj[i]}&`;
  }
  sortObjStr = sortObjStr.slice(0, -1) + 'hBVJfpzrXrrfeg7P2wp96zw1FbiM9Lxp';
  return md5(sortObjStr);
}

// 创建axios实例
const instance = axios.create();

// 请求拦截器
instance.interceptors.request.use(function (config) {
  // post请求把参数放到body中
  if (config.method == 'post') {
    let { params } = config.data;
    const data = new URLSearchParams();
    for (const i in params) {
      data.append(i, params[i]);
    }
    config.data = data;
    delete config.data.params;
    // header设置sign
    config.headers['sign'] = getHeaderMd5Sign(params);
  }
  // get请求把参数放到params中
  if (config.method == 'get') {
    let { params } = config;
    config.params = params;
    // header设置sign
    config.headers['sign'] = getHeaderMd5Sign(params);
  }
  const tokenData = JSON.parse(localStorage.getItem('leci-token')) || { token: '', uid:''};
  config.headers['token'] = tokenData.token;
  config.headers['uid'] = tokenData.uid;

  return config;
}, function (error) {
  return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  (res) => res.status === 200 ? Promise.resolve(res.data) : Promise.reject(res.data),
  // 请求失败
  (error) => {
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      return Promise.reject(response);
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
    }
  });
export default instance;